import React from 'react'
import { Script } from 'gatsby'


const PostStructuredData = ({ title, authorName, authSlug }) => {
    return (
        <Script id="structured-data-post" type="application/ld+json">
            {JSON.stringify(
                {
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": title,
                    // "datePublished": "2015-02-05T08:00:00+08:00",
                    // "dateModified": "2015-02-05T09:20:00+08:00",
                    "author": {
                        "@type": "Person",
                        "name": authorName,
                        "url": `https://donotpay.com/learn/authors/${authSlug}/`
                    },
                    "publisher": {
                        "@type": "Organization",
                        name: `DoNotPay`,
                        url: "https://donotpay.com/"
                    },
                })
            }
        </Script>
    )
}

export default PostStructuredData